<template>
  <ErrorModal />
  <q-dialog v-model="shareGrant" class="share-grant-main">
    <q-card class="share-dialog">
      <q-form
        @submit="shareSchemeEmit(address, message, name, accountName, grant.id)"
      >
        <q-card-section>
          <div class="text-h5">Item delen</div>
        </q-card-section>
        <q-card-section>
          <div class="share-text">
            <div class="row">
              <div class="column">
                <div class="row">
                  <div class="column">
                    <span class="share-info bold">
                      Te delen item:
                    </span>

                    <span class="share-info">
                      {{ grant.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="share-text-sm">
            <span class="share-info">
              Naam
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="name"
              dense
              :rules="requiredFieldRule"
              label="Voeg een naam toe"
            />
          </div>

          <div class="share-text-sm q-mt-md">
            <span class="share-info">
              Organisatienaam
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="accountName"
              dense
              :rules="requiredFieldRule"
              label="Voeg een accountnaam"
            />
          </div>
           <div class="share-text-sm q-mt-md">
            <span class="share-info">
              Emailadres
            </span>
              <q-input
                class="q-mt-sm"
                outlined
                v-model="address"
                dense
                type="email"
                :rules="[isValidEmail, requiredFieldRule]"
                label="Voeg een e-mailadres toe"
              />                
          </div> 
<!-- 
     <div class="share-text-sm q-mt-md recipients">
            <span class="share-info">
              Emailadres
            </span>
            <div class="row justify-between">
              <q-input
                class="q-mt-sm mail-input"
                outlined
                v-model="address"
                dense
                type="email"
                :rules="[isValidEmail, requiredFieldRule]"
                label="Voeg een e-mailadres toe"
                          @keydown.enter="addRecipient(address)"

              />
              <i
                class="las la-2x la-plus-circle action-icon q-ml-sm"
                @click="addRecipient(address)"
              >
                <q-tooltip> Opslaan </q-tooltip></i
              >
            </div>
          </div> 
           <div class="recipients-list q-mt-md">
            <span class="share-info">
              Recipients list
            </span>
            <div class="list" v-for="mail in recipientsList" :key="mail">
              <span class="recipient-mail">
                 {{ mail }}
              </span>
            </div>
          </div>  -->
        </q-card-section>

        <q-card-section>
          <div class="share-text-sm">
            <span class="share-info">
              Bericht *
            </span>
            <q-input
              :rules="requiredFieldRule"
              class="q-mt-sm"
              v-model="message"
              outlined
              type="textarea"
            />
          </div>
        </q-card-section>

        <q-card-section class="report-type">
          <q-select
            square
            outlined
            v-model="reportType"
            :options="options"
            label="Type rapport"
          />
        </q-card-section>

        <q-card-actions class="q-mt-sm" align="left">
          <q-btn
            flat
            label="Delen"
            class="submit-btn"
            color="white"
            no-caps
            type="submit"
          />
          <q-btn
            flat
            label="Annuleren"
            no-caps
            class="cancel-btn"
            v-close-popup
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import store from "../../store/index";
import MailingService from "../../services/mailing.service";
import ErrorModal from "./ErrorModal.vue";

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const shareGrant = computed({
      get: () => store.state.grantItems.shareGrantItem,
      set: (val) => store.commit("grantItems/disableShareGrantItem", val),
    });

    const grant = computed({
      get: () => store.state.grantItems.grantToShare,
    });

    const shareSchemeEmit = async (
      address,
      message,
      name,
      organisation,
      id
    ) => {
      MailingService.shareScheme(address, message, name, organisation, id);
    };

    const address = ref("");
    const message = ref("");
    const accountName = ref("");
    const name = ref("");

    const reportType = ref("Volledig rapport");

  /*   const recipientsList = ref([]);
    const addRecipient = (val) => {
   const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      if(emailPattern.test(val)) 
         recipientsList.value.push(val);
    };  */

    return {
    /*    recipientsList,
      addRecipient,  */
      options: [
        "Volledig rapport",
        /*   'Kerngegevens en samenvattingen',
        'Alleen kerngegevens', */
      ],
      reportType,
      name,
      accountName,
      message,
      address,
      shareSchemeEmit,
      shareGrant,
      grant,

      requiredFieldRule: [
        (val) => (val && val.length > 0) || "Veld is verplicht!",
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || "Ongeldig e-mailadres";
      },
    };
  },
};
</script>
